export default
{
  path: '/applySubAccount',
  name: 'apply-sub-account',
  component: () => import('@/views/User/newAccountManagement/applySubAccount.vue')
}



// WEBPACK FOOTER //
// ./src/router/modules/applySubAccount.js